import type { HistoryItem } from '../../types/terminal'
import styles from './TerminalLine.module.css'

interface TerminalLineProps {
  item: HistoryItem
}

export function TerminalLine({ item }: TerminalLineProps) {
  return (
    <div className={`${styles.line} ${styles[item.type]}`}>
      {item.type === 'input' ? (
        <span className={styles.command}>{item.content}</span>
      ) : (
        <span className={styles.output}>{item.content}</span>
      )}
    </div>
  )
}

